import {Tab, Tabs} from '@mui/material';
import {useEffect, useState} from 'react';
import {useLocation} from 'react-router-dom';
import NavigationActiveIcon from '@icons/NavigationActiveIcon';
import HomeButton from '../navigation-button/HomeButton';
import NetworkButton from '../navigation-button/NetworkButton';
import ServicesButton from '../navigation-button/ServicesButton';
import Header from './Header';

interface IProps {
	children: string | JSX.Element | JSX.Element[];
}

function getTabFromPath(pathname: string) {
	if (pathname.startsWith('/services')) {
		return 1;
	}
	if (pathname.startsWith('/network')) {
		return 2;
	}
	return 0;
}

export default function Main({children}: IProps) {
	const location = useLocation();
	const [tab, setTab] = useState(() => getTabFromPath(location.pathname));

	useEffect(() => {
		setTab(getTabFromPath(location.pathname));
	}, [location.pathname]);

	const handleChangeTab = (_event: React.SyntheticEvent, newValue: number) => {
		setTab(newValue);
	};
	return (
		<>
			<Header/>
			<div style={{height: 'calc(100% - 144px)'}} className="pb-2 overflow-scroll">
				{children}
			</div>
			<Tabs
				sx={{
					boxShadow: (theme) => theme.palette.mode === 'light' ? '0 -5px 5px -5px #ddd' : '0px -1px 2px 0px rgba(0, 0, 0, 0.13)',
					overflow: 'unset',
					bgcolor: 'background.default'
				}}
				className="fixed bottom-0 w-full navigation"
				value={tab}
				onChange={handleChangeTab}
				centered
				variant="fullWidth"
				TabIndicatorProps={{
					sx: {
						top: -22,
						backgroundColor: 'transparent',
						display: 'flex'
					},
					children: <NavigationActiveIcon/>
				}}>
				<Tab value={0} component={HomeButton}/>
				<Tab value={1} component={ServicesButton}/>
				<Tab value={2} component={NetworkButton}/>
			</Tabs>
		</>
	);
}
